import { render, staticRenderFns } from "./OportunidadeCard.vue?vue&type=template&id=634dc32c"
import script from "./OportunidadeCard.vue?vue&type=script&lang=js"
export * from "./OportunidadeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports